'use strict';

angular.module('amexReconciliationApp')
  .component('holdButton', {
    templateUrl: 'scripts/views/components/hold-button.html',
    controller: function (TransactionHoldService, SelectedTransactionService, SiteConfigModel, $translate, TransactionSearchModel) {
      var self = this;

      var CHARACTER_COUNT_LIMIT = 240;
      var DISPLAY_CHARACTER_COUNT_THRESHOLD = 200;

      var holdButtonText = {
        false: 'transactions.Release',
        true: 'transactions.Hold'
      };

      self.popoverTemplateUrl = 'scripts/views/modals/hold-data-modal.html';

      self.isOibEnabled = function () {
        return _.get(SiteConfigModel.siteConfig(), 'openItemBilling', false);
      };

      self.onClick = function () {
        if (self.reason.length > 0) {
          var transactionHoldStatus = {
            status: self.allTransactionsHeld(),
            reason: self.reason
          };
          TransactionHoldService.updateTransactionHoldStatus(SelectedTransactionService.selectedTransactions(), transactionHoldStatus, self.closePopover);
        }
      };

      self.buttonText = function () {
        self.popoverTitle = $translate.instant('transactions.HoldReleaseButtonTitle', {holdStatus: $translate.instant(holdButtonText[self.allTransactionsHeld()])});
        return holdButtonText[self.allTransactionsHeld()];
      };

      self.closePopover = function () {
        self.toggle = false;
        self.reason = '';
        self.charLength = 0;
      };

      self.isDisabled = function () {
        return SelectedTransactionService.selectedTransactionsCount() < 1 ||
          SelectedTransactionService.anyFullyLockedSelected() ||
          SelectedTransactionService.anyPartiallyLockedSelected();
      };

      self.showButton = function showButton() {
        return  self.isOibEnabled()  && SiteConfigModel.holdTransactionEnabledForRole(TransactionSearchModel.roleName());
      };

      self.allTransactionsHeld = function () {
        return _.every(SelectedTransactionService.selectedTransactions(), {transactionHold: {hold: false}});
      };

      self.renderCharacterCount = function () {
        return self.charLength > DISPLAY_CHARACTER_COUNT_THRESHOLD;
      };

      self.charactersRemaining = function () {
        return CHARACTER_COUNT_LIMIT - self.charLength;
      };

      self.countAndFilterText = function (text) {
        text = truncateToThreshold(text);
        text = removeControlCharacters(text);
        self.charLength = text.length;
      };

      function truncateToThreshold(text) {
        if (text.length > CHARACTER_COUNT_LIMIT) {
          text = text.substring(0, CHARACTER_COUNT_LIMIT);
        }
        return text;
      }

      function removeControlCharacters(text) {
        self.reason = text.replace(/[\x00-\x1F\x7F-\x9F]/g, '');
        return self.reason;
      }

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/holdButton.js
// module id = 452
// module chunks = 0